module.exports = __webpack_public_path__ + "static/media/logo.f720ce93.svg";